import { api } from "@/lib/api";

export async function fetchTiers() {
  const { data } = await api.get("/sponsor/tiers");
  return data;
}

export async function submitClaim(payload) {
  const { data } = await api.post("/sponsor/claim", payload);
  return data;
}

export async function verifyClaim(claim_id, code) {
  const { data } = await api.post("/sponsor/verify", { claim_id, code });
  return data;
}

export async function createCheckout(claim_id, tier_id, origin_url) {
  const { data } = await api.post("/sponsor/checkout", {
    claim_id,
    tier_id,
    origin_url,
  });
  return data;
}

export async function getCheckoutStatus(session_id) {
  const { data } = await api.get(`/sponsor/checkout-status/${session_id}`);
  return data;
}

export async function getClaimStatus(claim_id) {
  const { data } = await api.get(`/sponsor/claim/${claim_id}/status`);
  return data;
}

export async function uploadClaimProof(claim_id, file) {
  const fd = new FormData();
  fd.append("file", file);
  // IMPORTANT: do NOT set Content-Type manually for FormData. Axios sets it
  // automatically *with* the multipart boundary; setting it manually drops
  // the boundary and the server fails to parse the body — surfaces as a
  // generic "Network Error" in the browser when the proxy aborts.
  const { data } = await api.post(`/sponsor/claim/${claim_id}/proof`, fd, {
    timeout: 60000,
  });
  return data;
}
